import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Mescla `className` com a classe padrão de um componente portado de
 * `story-book-dtf`, resolvendo conflito de utilitário Tailwind (ex.: dois
 * `px-*` no mesmo elemento) — mesma dupla `clsx`+`tailwind-merge` que
 * `story-book-dtf/src/lib/utils.ts` usa por baixo do `cn` de lá.
 *
 * Só serve para os componentes portados em `componentes/` que usam classe
 * utilitária Tailwind (ver ADR-04); o resto do projeto continua consumindo
 * `componentes.css` por `className` semântica, sem passar por aqui.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
